import * as React from 'react'
import { graphql } from 'gatsby'

import Layout from 'src/uglib_components/layout'
import AreaMap from 'src/uglib_components/areaMap'
import { Bound } from 'src/uglib_utils/map';

const Page = ({ data }) => {
	const area = data.area;
	const name = area.name;
	const floor_name = area.relationships.floor.name;
	const bounds = data.bounds;
	const title = `${floor_name}: ${name}`;
	const image = area.relationships.floor.relationships.image.localFile.publicURL;
    const width = area.relationships.floor.image.width;
    const height = area.relationships.floor.image.height;
	
	const breadcrumbs = [
		{ 
			url: "/where",
			title: "Library Map",
		},
	]

	const bound_objects = bounds.edges.map((item) => {
		return new Bound(item.node.x1, item.node.y1, item.node.x2, item.node.y2, "proportional");
	});

    return (
      <Layout title={title} applyStyles={true} breadcrumbs={breadcrumbs}>
			<AreaMap image={image} description={area.description} width={width} height={height} bounds={bound_objects}/>

			<div style={{margin: '1em 0'}} className="text-center"><a href="/where" className="btn btn-primary">Back to Library Map</a></div>
      </Layout>
    )
}

export const query = graphql`
  	query ($id: String) {
		area: ugWhereisitAreaUgWhereisitArea(id: {eq: $id}) {
			code
			end
			id
			floor {
				drupal_internal__target_id
			}
			name
			description
			start
			status
			ug_whereisit_area_type
			relationships {
				floor {
					name
					code
					image {
						alt
						drupal_internal__target_id
						height
						title
						width
					}
					id
					relationships {
						image {
							id
							localFile {
								publicURL
							}
						}
					}
				}
			}
		}
		bounds: allUgWhereisitBoundUgWhereisitBound(
			filter: {relationships: {aid: {id: {eq: $id}}}}
		  ) {
			edges {
			  node {
				x1
				x2
				y1
				y2
				status
			  }
			}
		  }
  	}
`

export default Page